
<p *ngIf="message" style="text-align: center;"><b>{{message}}</b></p>
<br>
<p-progressBar mode="indeterminate"></p-progressBar>
<br>